import CrosshairsComponent from '~/viewportGrid/adapters/engine/overlays/Crosshairs';
import { RenderAdapter } from '~/viewportGrid/adapters/types';
import { useChangeVersion } from '~/viewportGrid/adapters/useChangeVersion';
import { planeViewOf } from '../ports/PlaneViewRenderAdapter';

interface TileCrosshairMountProps {
    renderer: RenderAdapter;
}

/**
 * Mounts the production crosshair overlay over one grid tile, driven by the
 * tile's engine view. The crosshair moves ONLY via its own line/handle
 * grabs (its document-level drag writes the shared intersection point);
 * cursor notifications and display-scale changes (a zoom, a fit or a
 * resize of the tile) re-render it in place. Renders nothing for
 * non-engine renderers (the mock adapters).
 */
export default function TileCrosshairMount({
    renderer,
}: TileCrosshairMountProps) {
    useChangeVersion(renderer.getCursorSource());
    useChangeVersion(renderer.getDisplayScaleSource());
    const view = planeViewOf(renderer);
    if (!view) {
        return null;
    }
    return <CrosshairsComponent view={view} />;
}
